import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";
import styles from "./ui.module.css";

export interface FiltersProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

/** Scope/filter bar container — children are filter controls. */
export function Filters({ children, className, ...rest }: FiltersProps) {
  return (
    <div className={cn(styles.filterBar, className)} {...rest}>
      {children}
    </div>
  );
}

export { Filters as FilterBar };
